import styled from '@emotion/styled';

export const ListItem = styled.li`
  display: flex;
  background-color: var(--white);
  border: 1px solid var(--border1);
  padding: 8px 16px;
  border-top: 0;
  gap: 8px;

  &:first-of-type {
    border-top: 1px solid var(--border1);
    border-radius: 8px 8px 0 0;
  }
`;

export const LeftContainer = styled.div`
  flex: 1;
`;

export const RightContainer = styled.div`
  //   min-width: 30%;
`;

export const StatusBadge = styled.span<{ status: 'paid' | 'pending' | 'failed' | 'succeeded' }>`
  display: inline-flex;
  align-items: center;
  padding: 4px 8px;
  border-radius: 12px;
  font-size: 12px;
  font-weight: 500;
  text-transform: capitalize;

  ${props => {
    switch (props.status) {
      case 'paid':
      case 'succeeded':
        return `
          background: #e8f5e8;
          color: #2d7d32;
          &:before {
            content: '✓';
            margin-right: 4px;
          }
        `;
      case 'pending':
        return `
          background: #fff3e0;
          color: #f57c00;
        `;
      case 'failed':
        return `
          background: #ffebee;
          color: #d32f2f;
        `;
      default:
        return `
          background: var(--neut7);
          color: var(--neut3);
        `;
    }
  }}
`;

export const DownloadButton = styled.button<{ isLoading?: boolean; disabled?: boolean }>`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 32px;
  border: none;
  border-radius: 6px;
  background: var(--neut6);
  cursor: pointer;
  transition: all 0.2s ease;
  opacity: ${props => (props.isLoading ? 0.7 : 1)};

  &:hover {
    background: var(--neut5);
  }
`;

export const LoadingSpinner = styled.div`
  width: 16px;
  height: 16px;
  border: 2px solid transparent;
  border-top: 2px solid white;
  border-radius: 50%;
  animation: spin 1s linear infinite;

  @keyframes spin {
    0% {
      transform: rotate(0deg);
    }
    100% {
      transform: rotate(360deg);
    }
  }
`;
